// utils/permissionHelper.js
export const hasPermission = (module, action) => {
  // ✅ Prefer the standard key "permissions", but fall back if needed
  const stored = localStorage.getItem("permissions") || localStorage.getItem("userPermissions");
  if (!stored) return false;

  let permissions;
  try {
    permissions = JSON.parse(stored);
  } catch {
    return false;
  }

  // Find by department name (case/space-insensitive)
  const perm = permissions.find(
    (p) => (p.fld_department || "").trim().toUpperCase() === (module || "").trim().toUpperCase()
  );
  if (!perm) return false;

  // Normalize "1         " → 1
  const view  = parseInt((perm.fld_view  || "").trim() || "0", 10);
  const entry = parseInt((perm.fld_entry || "").trim() || "0", 10);
  const edit  = parseInt((perm.fld_edit  || "").trim() || "0", 10);
  const del   = parseInt((perm.fld_delete|| "").trim() || "0", 10);

  switch (action) {
    case "view":   return view === 1;
    case "entry":  return entry === 1;
    case "edit":   return edit === 1;
    case "del": return del === 1;
    default:       return false;
  }
};
